module.exports = __webpack_public_path__ + "img/world-map-sm.e609260f.png";